<template>
  <div class="contact-information flex items-center">
    <div class="mr-1">
      <img src="/assets/img/code/Mrs.Chai.png" alt="" width="88" />
    </div>
    <div class="text">
      <div>
        <span class="sub-title">客服顾问：</span>
        <span class="text-theme-black-850">柴女士</span>
      </div>
      <div>
        <span class="sub-title">联系电话：</span>
        <span class="text-theme-black-850">18511821229</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactInformation'
}
</script>
